import { darken, lighten, useTheme } from '@mui/material';

import { AbsenceHistoryRowType } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable/components/AbsenceHistoryDialog/AbsenceHistoryDialogContent/useAbsenceHistoryData';

export const useSxStyles = () => {
  const theme = useTheme();

  const colors = {
    [AbsenceHistoryRowType.Delete]: 'rgba(255, 51, 0, 0.6)',
    [AbsenceHistoryRowType.Coming]: 'rgba(5, 164, 216, 0.6)',
    [AbsenceHistoryRowType.Ongoing]: 'rgba(146, 208, 80, 0.6)',
    [AbsenceHistoryRowType.Past]: 'rgba(214, 220, 219, 0.6)',
  };

  const getTableRowColor = (color: string) => ({
    backgroundColor: color,
    '&:hover': {
      backgroundColor: lighten(color, 0.2),
    },
    '&.Mui-selected': {
      backgroundColor: darken(color, 0.2),
      '&:hover': {
        backgroundColor: darken(color, 0.1),
      },
    },
  });

  const getLegendColor = (color: string) => ({
    color: color,
  });

  return {
    root: {
      display: 'grid',
      gridTemplateRows: 'auto 1fr auto',
      height: '100%',
    },
    dataGrid: {
      '.MuiDataGrid-row': {
        '&.absence-delete': getTableRowColor(
          colors[AbsenceHistoryRowType.Delete],
        ),
        '&.absence-coming': getTableRowColor(
          colors[AbsenceHistoryRowType.Coming],
        ),
        '&.absence-ongoing': getTableRowColor(
          colors[AbsenceHistoryRowType.Ongoing],
        ),
        '&.absence-past': getTableRowColor(colors[AbsenceHistoryRowType.Past]),
      },
    },
    legend: {
      marginLeft: theme.spacing(2),
    },
    legendDelete: getLegendColor(colors[AbsenceHistoryRowType.Delete]),
    legendComing: getLegendColor(colors[AbsenceHistoryRowType.Coming]),
    legendOngoing: getLegendColor(colors[AbsenceHistoryRowType.Ongoing]),
    legendPast: getLegendColor(colors[AbsenceHistoryRowType.Past]),
  };
};
